module.exports = __webpack_public_path__ + "static/media/silva-icon.2136afba.png";